<div class="h-auto flex flex-col gap-2 mx-1">
    <div class="px-4 py-6 bg-on-primary rounded-xl">
        <div class="mb-2">
            <app-main-title
                iconColor="text-custom-blue"
                iconSize="xl"
                titleSize="text-2xl font-medium"
                [icon]="['fas', ActionsEnum.FIELD_INTERVENTION]"
                [title]="'intervention' | transloco" />
        </div>

        <div class="flex flex-col pt-10">
            <div class="flex items-center justify-between gap-2">
                <div class="flex flex-row p-1 search">
                    <fa-icon
                        class="mr-2 text-custom-dark-grey text-subtitle-1"
                        matIconPrefix
                        size="lg"
                        [icon]="['fas', 'search']" />
                    <input
                        class="w-4/5 bg-transparent border-none text-base placeholder:text-gray-400 outline-none"
                        matInput
                        type="text"
                        [ngModel]="searchValue()"
                        [placeholder]="'search' | transloco"
                        (ngModelChange)="searchValue.set($event)" />
                </div>

                <app-button
                    [icon]="['fas', 'add']"
                    [label]="'newIntervention' | transloco"
                    [type]="ButtonType.PRIMARY"
                    (onClick)="openNewFieldInterventionModal()" />
            </div>
        </div>
    </div>

    @if (fieldInterventionsByStatus().length) {
        <div class="list pt-2 px-1">
            <mat-accordion multi>
                @for (interventionsByStatus of fieldInterventionsByStatus(); track interventionsByStatus.name) {
                    <app-field-intervention-list-item [interventionsByStatus]="interventionsByStatus" />
                }
            </mat-accordion>
        </div>
    } @else {
        <div class="bg-white h-full flex items-center justify-center pb-5">
            <app-no-data-to-display
                iconSize="4x"
                [displayedMessage]="
                    fieldInterventions().length
                        ? 'noCorrespondingFieldIntervention'
                        : 'noFieldInterventionForThisProject'
                " />
        </div>
    }
</div>
